/**
 * TanStack Query hooks for `vertical-aware-fraud-rules-igaming-vs-fintech-vs-e`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	verticalAwareFraudRulesIgamingVsFintechVsEQueryKeys,
	type CreateVerticalAwareFraudRulesIgamingVsFintechVsEBody,
	type ListVerticalAwareFraudRulesIgamingVsFintechVsEResponse,
	type VerticalAwareFraudRulesIgamingVsFintechVsERow,
} from "./api";

export function useVerticalAwareFraudRulesIgamingVsFintechVsEList(): UseQueryResult<ListVerticalAwareFraudRulesIgamingVsFintechVsEResponse, Error> {
	return useQuery({
		queryKey: verticalAwareFraudRulesIgamingVsFintechVsEQueryKeys.list(),
		queryFn: list,
	});
}

export function useVerticalAwareFraudRulesIgamingVsFintechVsECreate(): UseMutationResult<VerticalAwareFraudRulesIgamingVsFintechVsERow, Error, CreateVerticalAwareFraudRulesIgamingVsFintechVsEBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: verticalAwareFraudRulesIgamingVsFintechVsEQueryKeys.all });
		},
	});
}

export function useVerticalAwareFraudRulesIgamingVsFintechVsEDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: verticalAwareFraudRulesIgamingVsFintechVsEQueryKeys.all });
		},
	});
}
